<template>
  <page :basic="true">
    <span slot="header">Knowledge Check Preview</span>
    <span slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
      <router-link :to="{name: 'admin-knowledgecheck', params: {topic: topic.id, id: id}}">
        <i class="fas fa-exchange-alt"></i> Return to Admin
      </router-link>
    </span>
    <div class="topic-header" >
      <p v-html="model.knowledge_check.instructions"></p>
    </div>
    <div v-if="model" class="p-2">
      <kc-form :item="model" :default-params="{}" :is-preview="true"></kc-form>
    </div>
  </page>
</template>
<script>
import _ from 'lodash'
import api from '@/api/knowledgechecks/topic-knowledgecheck.js'
import page from '../../../templates/page'
import kcBase from './kc-base'
import kcForm from '@/components/pages/client/knowledge-checks/form'

export default {
  components:{
    kcForm,
    page
  },
  mixins:[
    kcBase
  ],
  data(){
    return{
      model: null,
      responses:{}
    }
  },
  mounted(){
    this.load()
  },
  methods:{
    load(){
      const params = _.clone(this.paramsWithId)

      return api.show(params).then((response) => {
        this.model = {
          knowledge_check: response.data.data,
          answers: []
        }

      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/preview.vue